module.exports = __webpack_public_path__ + "static/media/LoaderDNA_dark.dbec391b.gif";